function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgGoals = function SvgGoals(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement(Path, {
    fill: props.accentFillLine,
    d: "M10.67 23a1.6 1.6 0 0 0 1.18-.486q.483-.486.483-1.18v-1.667H14q.694 0 1.18-.488.486-.487.486-1.183a1.6 1.6 0 0 0-.486-1.18 1.61 1.61 0 0 0-1.18-.483h-1.667v-1.666q0-.695-.487-1.18A1.61 1.61 0 0 0 10.662 13a1.6 1.6 0 0 0-1.179.486A1.61 1.61 0 0 0 9 14.666v1.667H7.333q-.694 0-1.18.488-.487.487-.487 1.183t.486 1.18q.487.483 1.181.483H9v1.666q0 .695.487 1.18.488.487 1.183.487"
  }), /*#__PURE__*/React.createElement(Path, {
    fill: props.fillLine,
    fillRule: "evenodd",
    d: "M3.666 6a.97.97 0 0 1-.712-.29.98.98 0 0 1-.288-.716q0-.428.288-.71A.98.98 0 0 1 3.666 4h14q.425 0 .713.29a.98.98 0 0 1 .287.716.975.975 0 0 1-1 .994zm-.333 22q-.8 0-1.4-.6t-.6-1.4V10q0-.8.6-1.4t1.4-.6H18q.8 0 1.4.6T20 10v16q0 .8-.6 1.4T18 28zm0-2H18V10H3.333z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement(Path, {
    fill: props.accentFillLine,
    d: "M25.3 19.972a.95.95 0 0 1-.3-.7q0-.405.3-.705L26.866 17H22.3a.94.94 0 0 1-.69-.276.93.93 0 0 1-.277-.683q0-.408.3-.708t.7-.3h4.5l-1.567-1.566a.96.96 0 0 1-.3-.7q0-.4.302-.7t.717-.3.715.3l3.266 3.266q.3.3.3.7t-.3.7l-3.233 3.234q-.301.3-.718.3a.99.99 0 0 1-.715-.295"
  }));
};
export default SvgGoals;